import React, { useState, useEffect } from 'react';
import { 
    Container, Row, Col, Spinner, Button, Badge, 
    Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input 
} from 'reactstrap';
import { useParams, Link, useNavigate } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import Overview from './Overview';
import DetailsSection from './DetailsSection';

const JobDetails = () => {
    document.title = "Taşıma Detayları | HarmanaGEL";
    
    const { id } = useParams(); 
    const navigate = useNavigate();

    const [tripDetail, setTripDetail] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    
    // 1. Kullanıcı ve Rol Bilgileri
    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
    const userId = authUser?.ID;
    const hesapTuru = authUser?.HESAP_TURU || "";
    const isDriver = hesapTuru === 'Satıcı';

    // 2. Teklif Kontrol State'leri
    const [userOffer, setUserOffer] = useState(null);
    
    // 3. HIZLI TEKLİF (QUICK BID) STATE'LERİ
    const [quickBidModal, setQuickBidModal] = useState(false);
    const [quickBidLoading, setQuickBidLoading] = useState(false);
    const [quickBidDate, setQuickBidDate] = useState("");
    const [quickBidStartTime, setQuickBidStartTime] = useState("");
    const [quickBidEndTime, setQuickBidEndTime] = useState("");

    const toggleQuickBidModal = () => setQuickBidModal(!quickBidModal);

    useEffect(() => {
        const fetchAdvertDetails = async () => {
            setIsLoading(true);
            try {
                // API SORGUSU
                const expandQuery = "Users_Car,ADRESLER,Invoince,Advert_Type,ILAN_TEKLIFLERI($expand=KULLANICILAR),Advert_DeliveryStatus,Advert_Document,Advert_Expenses,Advert_Task_Report,Advert_Rating";
                const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/ILANLAR?$filter=ID eq ${id}&$expand=${expandQuery}`);
                
                if (!response.ok) {
                    throw new Error("Veri çekilemedi");
                }
                
                const result = await response.json();
                const advertData = result.value ? result.value[0] : (Array.isArray(result) ? result[0] : result);

                if (advertData) {
                    const car = advertData.Users_Car || {};
                    const location = Array.isArray(advertData.ADRESLER) ? advertData.ADRESLER[0] : (advertData.ADRESLER || {});
                    const invoice = advertData.Invoince || null;
                    const advertType = advertData.Advert_Type || {};
                    const offers = advertData.ILAN_TEKLIFLERI || [];

                    // Mevcut Teklif Kontrolü
                    // Mevcut Teklif Kontrolü
if (userId) {
    const existingOffer = offers.find(offer => offer.Users_ID === userId);
    setUserOffer(existingOffer || null);
}

                    // STATE HARİTALAMASI
                    setTripDetail({
                        id: advertData.ID,
                        advertTypeTitle: advertType.Advert_Type_Title || "Bilinmiyor",
                        direction: advertData.Direction_Type || "Belirtilmedi",
                        distance: advertData.Advert_KM ? `${advertData.Advert_KM} km` : (location.Km ? `${location.Km} km` : "-"),
                        duration: advertData.Estimated_Duration || "00:00",
                        price: advertData.Price || 0,
                        fuelStatus: advertData.Fuel_Status || "Bilgi yok",
                        customerNotes: advertData.Customer_Notes || "Müşteri notu bulunmuyor.",
                        isAdminCheck: advertData.Is_AdminCheck,
                        isActive: advertData.Is_Active,
                        
                        start: {
                            city: `${location.Start_City_Code || ''} ${location.ADRESLER_StartAddress?.split(',')[0] || ''}`,
                            date: advertData.Advert_DateTime ? new Date(advertData.Advert_DateTime).toLocaleString('tr-TR') : "-",
                            address: location.ADRESLER_StartAddress || "-",
                            countryFlag: "🇹🇷" 
                        },
                        end: {
                            city: `${location.Finish_City_Code || ''} ${location.ADRESLER_FinishAddress?.split(',')[0] || ''}`,
                            date: advertData.Advert_DateTime2 ? new Date(advertData.Advert_DateTime2).toLocaleString('tr-TR') : "-",
                            address: location.ADRESLER_FinishAddress || "-",
                            countryFlag: "🇹🇷"
                        },
                        deadline: advertData.Advert_DateTime3 ? new Date(advertData.Advert_DateTime3).toLocaleString('tr-TR') : "-",

                        vehicle: {
                            brand: car.MARKA || "-",
                            model: car.Users_Car_Model || "-",
                            engine: car.Engine_Type || "-",
                            bodyType: car.Car_Body_Type || "-",
                            plate: car.PLAKA || "-",
                            chassis: car.ChassisInformation || "-"
                        },

                        invoice: invoice ? {
                            id: invoice.ID,
                            number: invoice.SIPARIS_NO,
                            status: invoice.SIPARIS_DURUMU,
                            totalAmount: invoice.TOPLAM_TUTAR
                        } : null,

                        offers: offers,
                        deliveryStatus: advertData.Advert_DeliveryStatus || [],
                        documents: advertData.Advert_Document || [],
                        expenses: advertData.Advert_Expenses || [],
                        taskReports: advertData.Advert_Task_Report || [],
                        ratings: advertData.Advert_Rating || [],
                        
                        services: [
                            "Geri dönmeden önce yolculuğun sonunda beklemek",
                            "Profesyonel sürücü talep edildi"
                        ]
                    });
                } else {
                    setTripDetail(null);
                }
            } catch (error) {
                console.error("Detaylar çekilirken hata:", error);
                setTripDetail(null);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchAdvertDetails();
        }
    }, [id, userId]);

    // OData formatına zamanı çevirme (örnek: "14:30" -> "PT14H30M0S")
    const formatToDuration = (timeStr) => {
        if (!timeStr) return null;
        const [h, m] = timeStr.split(':');
        return `PT${parseInt(h)}H${parseInt(m)}M0S`;
    };

    // HIZLI TEKLİF GÖNDERME FONKSİYONU
    const handleQuickBidSubmit = async () => {
        if (!quickBidDate || !quickBidStartTime || !quickBidEndTime) {
            alert("Lütfen teslimat tarihi ile başlangıç ve bitiş saatini seçiniz.");
            return;
        }

        try {
            setQuickBidLoading(true);

            const price = Number(tripDetail.price);

            const payload = {
                Advert_ID: Number(tripDetail.id),
                Users_ID: Number(userId),
                Price: price,
                Travel_Expenses: 0,
                Delivery_Date: quickBidDate, // <input type="date"> YYYY-MM-DD verir
                Start_Time: formatToDuration(quickBidStartTime),
                End_Time: formatToDuration(quickBidEndTime),
                Own_Offer: price,
                OLUSTURMA_TARIHI: new Date().toISOString(),
                IsUpdated: false
            };

            const response = await fetch("https://harmanagelapi.stechomeyazilim.info/ILAN_TEKLIFLERI", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error("Teklif gönderilemedi");
            }

            alert(`Teklifiniz ${price.toFixed(2)} TL olarak başarıyla gönderildi!`);
            
           setQuickBidModal(false);
// Formdan gönderdiğimiz verilerle userOffer state'ini dolduruyoruz
setUserOffer({
    Price: price,
    Delivery_Date: quickBidDate,
    OLUSTURMA_TARIHI: new Date().toISOString()
});
            
            // Formu temizle
            setQuickBidDate("");
            setQuickBidStartTime("");
            setQuickBidEndTime("");

        } catch (error) {
            console.error("QUICK BID ERROR:", error);
            alert("Hızlı teklif gönderilirken bir hata oluştu.");
        } finally {
            setQuickBidLoading(false);
        }
    };

    return (
        <React.Fragment>
             <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Uygun Geziler" breadcrumbItem="Taşıma Detayları" />

                    <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                            <Link to="/job-list" className="text-dark me-3">
                                <i className="mdi mdi-arrow-left fs-3"></i>
                            </Link>
                            <h3 className="mb-0">Taşıma detayları n°{id}</h3>
                            
                            {tripDetail && (
                                <span className={`badge ms-3 ${tripDetail.isAdminCheck ? 'bg-success' : 'bg-warning'}`}>
                                    {tripDetail.isAdminCheck ? 'Aktif (Onaylı)' : 'Pasif (Onay Bekliyor)'}
                                </span>
                            )}
                        </div>

                        {/* AKSİYON BUTONLARI */}
                        {tripDetail && isDriver && (
                            <div className="d-flex gap-2">
                               {userOffer ? (
    <div className="d-flex flex-column align-items-end border border-info p-2 rounded bg-soft-info">
        <Badge color="info" className="fs-6 mb-2">
            <i className="mdi mdi-check-all me-1"></i> Teklifiniz Aktif
        </Badge>
        <div className="text-end">
            <div className="text-muted fw-bold mb-1">
                <i className="mdi mdi-cash-multiple me-1"></i> 
                Tutar: {Number(userOffer.Price).toFixed(2)} TL
            </div>
            <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                <i className="mdi mdi-calendar-clock me-1"></i> 
                Tarih: {new Date(userOffer.OLUSTURMA_TARIHI).toLocaleString('tr-TR')}
            </div>
        </div>
    </div>
) : (
                                    <>
                                        <Button color="warning" outline onClick={toggleQuickBidModal}>
                                            <i className="mdi mdi-flash me-1"></i> Hızlı Teklif Ver
                                        </Button>
                                        <Button color="primary" onClick={() => navigate(`/expense-entry/${id}`)}>
                                            Teklif Oluşturmaya Başla <i className="mdi mdi-chevron-right ms-1"></i>
                                        </Button>
                                    </>
                                )}
                            </div>
                        )}
                    </div>

                    {isLoading ? (
                        <div className="text-center py-5">
                            <Spinner color="primary" /> <p className="mt-2">Detaylar yükleniyor...</p>
                        </div>
                    ) : tripDetail ? (
                        <Row>
                            <DetailsSection detail={tripDetail} />
                            <Overview detail={tripDetail} />
                        </Row>
                    ) : (
                        <div className="alert alert-danger">Kayıt bulunamadı veya bir hata oluştu.</div>
                    )}
                </Container>
            </div>

            {/* HIZLI TEKLİF MODALI */}
            <Modal isOpen={quickBidModal} toggle={toggleQuickBidModal} centered>
                <ModalHeader toggle={toggleQuickBidModal} className="bg-soft-warning">
                    <i className="mdi mdi-flash text-warning me-2"></i>Hızlı Teklif Ver
                </ModalHeader>
                <ModalBody>
                    <div className="alert alert-warning px-3 py-2 mb-4">
                        Bu görev için teklifiniz ilan fiyatı olan <strong>{tripDetail?.price ? Number(tripDetail.price).toFixed(2) : "0.00"} TL</strong> üzerinden otomatik gönderilecektir. Lütfen teslimat tarihini ve saat aralığını seçiniz.
                    </div>
                    
                    <FormGroup>
                        <Label className="fw-bold">Teslimat Tarihi</Label>
                        <Input 
                            type="date" 
                            value={quickBidDate} 
                            onChange={e => setQuickBidDate(e.target.value)} 
                        />
                    </FormGroup>
                    
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="fw-bold">Başlangıç Saati</Label>
                                <Input 
                                    type="time" 
                                    value={quickBidStartTime} 
                                    onChange={e => setQuickBidStartTime(e.target.value)} 
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label className="fw-bold">Bitiş Saati</Label>
                                <Input 
                                    type="time" 
                                    value={quickBidEndTime} 
                                    onChange={e => setQuickBidEndTime(e.target.value)} 
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="light" onClick={toggleQuickBidModal} disabled={quickBidLoading}>Vazgeç</Button>
                    <Button color="warning" onClick={handleQuickBidSubmit} disabled={quickBidLoading}>
                        {quickBidLoading ? <Spinner size="sm" color="light" /> : "Teklifi Gönder"}
                    </Button>
                </ModalFooter>
            </Modal>

        </React.Fragment>
    );
}

export default JobDetails;